import type {
    SidebarActionPlacement
} from "../../type";

export const useStyles = ({
    placement,
    height
}: {
    placement: SidebarActionPlacement;
    height: number;
}) => {
    return {
        container: {
            marginTop: (height - placement.hitSize) / 2
        }
    };
};
